"use client";

import { ChevronDown, ShieldCheck } from "lucide-react";
import * as React from "react";

import { cn } from "../utils";

export type PrivacyNoteProps = {
  summary?: string;
  children?: React.ReactNode;
  defaultOpen?: boolean;
  className?: string;
};

export function PrivacyNote({
  summary = "Your answers are always private & protected.",
  children = "This conversation is encrypted and protected by HIPAA. Only your provider sees your health information.",
  defaultOpen = false,
  className,
}: PrivacyNoteProps) {
  const [open, setOpen] = React.useState(defaultOpen);
  const bodyRef = React.useRef<HTMLDivElement>(null);

  return (
    <div className={cn("flex flex-col max-w-lg", className)} data-slot="privacy-note">
      <button
        type="button"
        className="flex w-full items-center gap-1.5 border-none bg-transparent p-0 text-left text-[13px] tracking-tight text-text-agent/70 font-medium cursor-pointer"
        onClick={() => setOpen((o) => !o)}
        aria-expanded={open}
      >
        <ShieldCheck size={16} className="shrink-0" strokeWidth={1.5} aria-hidden />
        <span className="flex-1">{summary}</span>
        <ChevronDown
          size={12}
          className={cn("shrink-0 transition-transform", open && "rotate-180")}
          strokeWidth={1.4}
          aria-hidden
        />
      </button>
      <div
        ref={bodyRef}
        className={cn("transition-opacity pl-[23px]", open ? "opacity-100" : "opacity-0")}
        aria-hidden={!open}
      >
        <div className="overflow-hidden">
          <p className="mt-1.5 text-xs leading-relaxed text-text-agent/50">{children}</p>
        </div>
      </div>
    </div>
  );
}
